export default __webpack_public_path__ + "static/media/product3.35d7f3fa.png";